import React from 'react';
import './Legal.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Terms and Conditions</h1>
          <p>Website Terms and Conditions of Use</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section">
              <h3>1. Terms</h3>
              <p>
                By accessing this Website, accessible from http://1waydoor.com/, you are
                agreeing to be bound by these Website Terms and Conditions of Use and agree
                that you are responsible for the agreement with any applicable local laws.
                If you disagree with any of these terms, you are prohibited from accessing
                this site. The materials contained in this Website are protected by copyright
                and trade mark law.
              </p>
            </div>

            <div className="legal-section">
              <h3>2. Use License</h3>
              <p>
                Permission is granted to temporarily download one copy of the materials on
                1WayDoor's Website for personal, non-commercial transitory viewing only.
                This is the grant of a license, not a transfer of title, and under this
                license you may not:
              </p>
              <ul>
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on 1WayDoor's Website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
              <p>
                This will let 1WayDoor terminate upon violations of any of these restrictions.
                Upon termination, your viewing right will also be terminated and you should
                destroy any downloaded materials in your possession whether it is printed or
                electronic format.
              </p>
            </div>

            <div className="legal-section">
              <h3>3. Disclaimer</h3>
              <p>
                All the materials on 1WayDoor's Website are provided "as is". 1WayDoor makes
                no warranties, may it be expressed or implied, therefore negates all other
                warranties. Furthermore, 1WayDoor does not make any representations concerning
                the accuracy or reliability of the use of the materials on its Website or
                otherwise relating to such materials or any sites linked to this Website.
              </p>
            </div>

            <div className="legal-section">
              <h3>4. Limitations</h3>
              <p>
                1WayDoor or its suppliers will not be held accountable for any damages that
                will arise with the use or inability to use the materials on 1WayDoor's
                Website, even if 1WayDoor or an authorized representative of this Website
                has been notified, orally or written, of the possibility of such damage.
              </p>
            </div>

            <div className="legal-section">
              <h3>5. Revisions and Errata</h3>
              <p>
                The materials appearing on 1WayDoor's Website may include technical,
                typographical, or photographic errors. 1WayDoor will not promise that any
                of the materials in this Website are accurate, complete, or current.
                1WayDoor may change the materials contained on its Website at any time
                without notice.
              </p>
            </div>

            <div className="legal-section">
              <h3>6. Links</h3>
              <p>
                1WayDoor has not reviewed all of the sites linked to its Website and is not
                responsible for the contents of any such linked site. The presence of any
                link does not imply endorsement by 1WayDoor of the site. The use of any
                linked website is at the user's own risk.
              </p>
            </div>

            <div className="legal-section">
              <h3>7. Site Terms of Use Modifications</h3>
              <p>
                1WayDoor may revise these Terms of Use for its Website at any time without
                prior notice. By using this Website, you are agreeing to be bound by the
                current version of these Terms and Conditions of Use.
              </p>
            </div>

            <div className="legal-section">
              <h3>8. Your Privacy</h3>
              <p>Please read our Privacy Policy.</p>
            </div>

            <div className="legal-section">
              <h3>9. Governing Law</h3>
              <p>
                Any claim related to 1WayDoor's Website shall be governed by the laws of
                the United States without regards to its conflict of law provisions.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
